module.exports = __webpack_public_path__ + "0a53bcdbf01aa136fd202fab9481f56d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img2_3.jpg
// module id = 557
// module chunks = 0